import QualityControlStore from "./QualityControl/QualityControlStore";
import QCInspectorDashboardStore from "./InspectorDashboard/QCInspectorDashboard.Store";
import QCManagerDashboardStore from "./ManagerDashboard/QCManagerDashboard.Store";
import QCInspectionStore from "./InspectionForm/QCInspection.Store";
import QCApprovalStore from "./ApprovalWorkflow/QCApproval.Store";

const qualityControlStoreList = [
    { name: "qualityControlStore", store: QualityControlStore },
    // New QC Workflow Stores
    { name: "qcInspectorDashboardStore", store: QCInspectorDashboardStore },
    { name: "qcManagerDashboardStore", store: QCManagerDashboardStore },
    { name: "qcInspectionStore", store: QCInspectionStore },
    { name: "qcApprovalStore", store: QCApprovalStore },
];

export default qualityControlStoreList;
